import React from "react";
import { Button } from "./ui/button";
import { Phone, ArrowRight, Sparkles } from "lucide-react";

const MidPageCTA = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="py-16 bg-gradient-to-r from-blue-600 to-orange-500 relative overflow-hidden">
      {/* Background Animation */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-4 left-4 w-72 h-72 bg-white rounded-full mix-blend-overlay animate-pulse-soft"></div>
        <div className="absolute bottom-4 right-4 w-96 h-96 bg-white rounded-full mix-blend-overlay animate-float"></div>
      </div>

      <div className="container mx-auto px-6 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Sparkles Animation */}
          <div className="flex justify-center mb-6">
            <Sparkles className="w-12 h-12 text-yellow-300 animate-pulse" />
          </div>

          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6 leading-tight">
            Ready to Transform Your
            <span className="block">Digital Presence?</span>
          </h2>

          <p className="text-xl md:text-2xl text-blue-100 mb-8 max-w-3xl mx-auto leading-relaxed px-4">
            Jangan biarkan kompetitor Anda unggul. Mulai project multimedia Anda
            bersama tim profesional RanselPro sekarang juga!
          </p>

          {/* Animated CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-6 justify-center items-center mb-8">
            <a
              href="https://wa.me/6285133079588?text=Halo%20RanselPro!%20Saya%20ingin%20konsultasi%20tentang%20layanan%20multimedia."
              target="_blank"
              rel="noopener noreferrer"
            >
              {" "}
              <Button
                size="lg"
                // onClick={() => scrollToSection("contact")}
                className="bg-white text-blue-600 hover:bg-blue-50 px-8 py-4 text-lg font-bold rounded-2xl shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300 animate-pulse-cta group"
              >
                <Phone className="w-6 h-6 mr-3 group-hover:rotate-12 transition-transform duration-300" />
                Mulai Project Sekarang
              </Button>
            </a>

            <Button
              size="lg"
              variant="outline"
              onClick={() => scrollToSection("portfolio")}
              className="border-2 border-white/50 text-white hover:bg-white/10 backdrop-blur-md px-8 py-4 text-lg font-bold rounded-2xl hover:border-white transition-all duration-300 group"
            >
              Lihat Case Study
              <ArrowRight className="w-6 h-6 ml-3 group-hover:translate-x-1 transition-transform duration-300" />
            </Button>
          </div>

          {/* Urgency Badge */}
          <div className="inline-flex items-center px-6 py-3 bg-yellow-400 text-gray-900 rounded-full font-semibold text-sm sm:text-base animate-bounce">
            🔥 Free Consultation - Terbatas 48 Jam!
          </div>
        </div>
      </div>
    </section>
  );
};

export default MidPageCTA;
